import React from 'react';
import '../css/Hero.css';
import Navbar from './NavBar';
import Badge from './Badge';
import desktopVideo from '../images/l1.mp4';
import mobileVideo from '../images/l2.mp4';

function Hero() {
  return (
    <div className='portfolio-wrapper'>
      <video className='hero-video-bg' autoPlay loop muted playsInline>
        <source src={mobileVideo} type="video/mp4" media="(max-width: 768px)" />
        <source src={desktopVideo} type="video/mp4" />
      </video>
      <Navbar></Navbar>
      <div className="portfolio-container">
          {/* <Badge><span className='badge-star'>✦</span>Open to work</Badge> */}
        <div className="hero-section">
          <div className="hero-content">
            <span>Hi I'm Kishore,</span>
            <br></br><span>Software Engineer<span className='dot'>.</span></span>
            <br></br><span className='india'>from India.</span>
          </div>

        </div>
        <div className='hero-para'>"Jack of all trades, master of none, <br className='break'></br>but oftentimes better than a master of one."</div>
      </div>
    </div>


  );
}

export default Hero;